// src/pages/Dashboard.jsx
import React, { useEffect, useState, useCallback, useRef } from "react";
import { socket } from "../../Config/socket.io"
import {
  ProfileOutlined,
  PieChartOutlined,
  DollarOutlined,
  FieldTimeOutlined,
  LogoutOutlined,
  FileDoneOutlined,
  SettingOutlined,
  UserOutlined,
  WalletOutlined,
  MessageOutlined,
  MenuOutlined,
  BellFilled,
  UnlockOutlined,
  CloseCircleOutlined,
  StockOutlined,
  LineChartOutlined,
  RiseOutlined,
  SlidersOutlined,
  LoadingOutlined,
  NotificationOutlined,
  ClockCircleOutlined,
  SettingFilled,
  SafetyCertificateOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  DashboardOutlined
} from "@ant-design/icons";

import {
  Layout,
  Menu,
  theme,
  Tooltip,
  message,
  Drawer,
  Badge,
  Dropdown,
  Avatar,
  Button,
  Modal,
} from "antd";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";
import Loadingpage from "../Loadingpage/Loadingpage";
import consts from "../../constant";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdmin } from "../../store/slices/userSlice";

// import PageSpin from "../Loadingpage/Loadingpage";
const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return { key, icon, children, label };
}

const allItems = [
  getItem("Dashboard", "/dashboard", <ProfileOutlined />),
  // getItem("Users", "/users", <PieChartOutlined />),
  getItem("Users", "/usersHistory", <UserOutlined />),
  getItem("Users Wallet", "/users", <WalletOutlined />),
  getItem("KYC Management", "/kyc", <UnlockOutlined />),
  getItem("History", "/crypto", <ClockCircleOutlined />, [
    getItem("Binary History ", "/crypto/binary-history", <StockOutlined />),
    // getItem("UpDown ", "/crypto/updown", <LineChartOutlined />),
    // getItem("HighLow Spread ", "/crypto/highlowspread", <RiseOutlined />),
    // getItem("TapTrade ", "/crypto/taptrade", <SlidersOutlined />),
    getItem("Spin And Win History", "/crypto/spinandwin", <SlidersOutlined />),
  ]),
  getItem("Trade Settings", "/tradesetting", <SettingOutlined />, [
    getItem("Binary ", "/tradesetting/binary-setting", <StockOutlined />),
    getItem("Automated RTP Engine", "/tradesetting/rtp-engine", <DashboardOutlined />),
    getItem("Patterns", "/tradesetting/patterns", <SlidersOutlined />),
    getItem(
      <Tooltip title="Manage Time and Amount" placement="top">
        Manage Time and Amount
      </Tooltip>,
      "/tradesetting/manage-time-amount",
      <FieldTimeOutlined />,
    ),
    getItem(
      <Tooltip title="Profit Percentage" placement="top">
        Profit Percentage
      </Tooltip>,
      "/tradesetting/profit-segments",
      <PieChartOutlined />,
    ),
    // getItem("UpDown ", "/tradesetting/updownsetting", <LineChartOutlined />),
    //   getItem(
    //     "HighLow Spread ",
    //     "/tradesetting/highlowspreadsetting",
    //     <RiseOutlined />,
    //   ),
    //   getItem("TapTrade ", "/tradesetting/taptradesetting", <SlidersOutlined />),
    getItem(
      "Spin And Win Settings",
      "/tradesetting/spinandwinsetting",
      <SlidersOutlined />,
    ),
    getItem("Points Section", "/tradesetting/points", <SlidersOutlined />),
  ]),

  getItem("Payment Settings", "/payment-settings", <SettingFilled />, [
    getItem("Crypto Settings", "/payment-settings/crypto", <StockOutlined />),
    getItem("Fiat Settings", "/payment-settings/fiat", <DollarOutlined />),
  ]),
  getItem("Deposit", "/deposit-history", <DollarOutlined />),
  getItem("Withdraw", "/withdraw", <DollarOutlined />),
  // getItem("Create Own Assets", "/createownassets", <DollarOutlined />),
  // getItem("Winning Percent", "/winpercent", <DollarCircleFilled />),
  getItem("Pairs", "/pairs", <ProfileOutlined />),
  // getItem("Open Orders", "/operorders", <FileDoneOutlined />),
  // getItem("Position Orders", "/positionorders", <ScheduleOutlined />),
  // getItem("Trade History", "/tradehistory", <FieldTimeOutlined />),
  // getItem("Position History", "/positionhistory", <FieldTimeOutlined />),
  getItem("Supports", "/supports", <MessageOutlined />),
  getItem("Sub Admin", "/subadmin", <UsergroupAddOutlined />, [
    getItem("Role Manage ", "/subadmin/rolemanage", <UserOutlined />),
    getItem("Admin Manage", "/subadmin/adminmanage", <UserSwitchOutlined />),
    // getItem("SubAdmin Activities", "/subadmin/activities", <BellFilled />),
  ]),

  getItem(
    "Under Maintenance",
    "/under-maintenance",
    <SafetyCertificateOutlined />,
  ),
  getItem("Announcements", "/announcements", <NotificationOutlined />),
  getItem("Settings", "/settings", <SettingOutlined />),
];

// Individual CryptoTrade child keys → permission label mapping
const CRYPTO_CHILD_PERMISSION_MAP = {
  "/crypto/highlow": "HighLow",
  "/crypto/updown": "UpDown",
  "/crypto/highlowspread": "HighLow Spread",
  "/crypto/taptrade": "TapTrade",
  "/crypto/spinandwin": "Spin And Win",
  "/crypto/binary-history": "HighLow", // Map Binary History to HighLow permission
};
const Dashboard = () => {

  const dispatch = useDispatch();
  const { permissions, role, _id: reduxAdminId } = useSelector((state) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [image, setImage] = useState(null);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [clearingId, setClearingId] = useState(null); // ID of individual notification being cleared
  const [isClearingAll, setIsClearingAll] = useState(false); // Flag for "Clear All" action

  const currentAdminRef = useRef(null);
  useEffect(() => {
    currentAdminRef.current = reduxAdminId;
  }, [reduxAdminId]);

  // const getProfile = async () => {
  //   try {
  //     const response = await axios.post(`${consts.BackendUrl}/getAdmin`, {}, {
  //       headers: {
  //         Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
  //       },
  //     });
  //     if (response?.data?.success) {
  //       const result = response.data.result;
  //       setUserRole(result.role);
  //       localStorage.setItem("adminId", result._id); // Store ID for notification scoping
  //       if (result.access && result.access.permissions) {
  //         setPermissions(result.access.permissions);
  //         localStorage.setItem("permissions", JSON.stringify(result.access.permissions));
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Failed to fetch admin profile", error);
  //   } finally {
  //     setProfileLoaded(true);
  //   }
  // };

  useEffect(() => {
    dispatch(fetchAdmin());
  }, []);

  const siderWidth = collapsed ? 80 : 0;
  const navigate = useNavigate();
  const location = useLocation();

  // Centralized notification type → permission label mapping
  const NOTIF_PERMISSION_MAP = {
    "user": "Users",
    "deposit": "Deposit",
    "paymentsettings": "Payment Settings",
    "withdraw": "Withdraw",
    "settings": "Settings",
    "pairs": "Pairs",
    "tradesettings": "Trade Settings",
    "support": "Supports",
    "kyc": "KYC Management",
    "trade": "Crypto History",
    "highlow": "HighLow",
    "updown": "UpDown",
    "highlowspread": "HighLow Spread",
    "taptrade": "TapTrade",
    "spinandwin": "Spin And Win",
  };

  const ADMIN_NOTIFICATION_TYPES = Object.keys(NOTIF_PERMISSION_MAP);
  const [notifications, setNotifications] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const getNotifications = async () => {
    // Only fetch for admin/superadmin/subadmin
    if (role && !["admin", "superadmin", "subadmin"].includes(role)) return;

    try {
      setIsFetching(true);
      const response = await axios.post(
        `${consts?.BackendUrl}/notification/getNotification`,
        { limit: visibleCount },
        {
          headers: {
            Authorization: localStorage.getItem("Jetix"),
          },
        },
      );
      const data = await response?.data;
      if (data?.success && data?.result?.length > 0) {
        // Admin/superadmin: show everything; subadmin: filter groups by their permissions
        const userPermissions = (permissions || JSON.parse(localStorage.getItem("permissions") || "[]")).map(p => p.toLowerCase().trim());

        const filtered = data.result.filter(group => {
          const type = (group.type || "").replace(/\s+/g, '').toLowerCase();
          if (!ADMIN_NOTIFICATION_TYPES.includes(type)) return false;

          if (role === "admin" || role === "superadmin") return true;

          // Subadmin: only show if they have the matching permission for this group type
          const requiredPermission = NOTIF_PERMISSION_MAP[type];
          return requiredPermission && userPermissions.includes(requiredPermission.toLowerCase().trim());
        });

        setNotifications(filtered);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      setNotifications([]);
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleClose = async (payload = {}) => {
    if (payload.id) {
      setClearingId(payload.id);
    } else {
      setIsClearingAll(true);
    }
    try {
      const response = await axios.post(
        `${consts?.BackendUrl}/notification/updateNotification`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("Jetix"),
          },
        },
      );
      const data = await response?.data;

      if (data?.success) {
        getNotifications();
      }
    } catch (error) {
      getNotifications();
      console.log(error);
    } finally {
      setClearingId(null);
      setIsClearingAll(false);
    }
  };

  // Remove the prefix `/bitgetAdmin/` and take only the first segment
  const currentKey = location.pathname.replace(`/${consts.route}`, "");
  const [selectedKey, setSelectedKey] = useState(currentKey);

  const [activeNotificationTab, setActiveNotificationTab] = useState("All");
  const [visibleCount, setVisibleCount] = useState(15);

  useEffect(() => {
    setVisibleCount(15);
  }, [activeNotificationTab]);

  // Dynamic notification tabs based on permissions
  const ALL_NOTIFICATION_CATEGORIES = ["User", "Settings", "Pairs", "Trade", "Trade Setting", "Support", "Deposit", "Withdraw", "KYC"];
  const [notificationCategories, setNotificationCategories] = useState(["All", ...ALL_NOTIFICATION_CATEGORIES]);

  useEffect(() => {
    if (role === "admin" || role === "superadmin") {
      setNotificationCategories(["All", ...ALL_NOTIFICATION_CATEGORIES]);
      setActiveNotificationTab("All");
    } else {
      const userPermissions = (permissions || JSON.parse(localStorage.getItem("permissions") || "[]")).map(p => p.toLowerCase().trim());
      const filtered = ALL_NOTIFICATION_CATEGORIES.filter(cat => {
        // Map category Label correctly to permission string
        const catMap = {
          "User": "Users",
          "Settings": "Settings",
          "Payment Settings": "Payment Settings",
          "Pairs": "Pairs",
          "Trade": "Crypto History",
          "Trade Setting": "Trade Settings",
          "Support": "Supports",
          "Deposit": "Deposit",
          "Withdraw": "Withdraw",
          "KYC": "KYC Management"
        };
        const required = catMap[cat];
        return required && userPermissions.includes(required.toLowerCase().trim());
      });
      setNotificationCategories([...filtered]);
      if (filtered.length > 0) {
        setActiveNotificationTab(filtered[0]);
      }
    }
  }, [role, permissions]);

  const scrollRef = useRef(null);

  const setScrollRef = useCallback(node => {
    if (scrollRef.current) {
      scrollRef.current.removeEventListener("wheel", scrollRef.current._handleWheel);
    }

    if (node) {
      const handleWheel = (e) => {
        if (e.deltaY !== 0) {
          e.preventDefault();
          node.scrollLeft += e.deltaY;
        }
      };
      node._handleWheel = handleWheel;
      node.addEventListener("wheel", handleWheel, { passive: false });
    }
    scrollRef.current = node;
  }, []);

  useEffect(() => {
    setSelectedKey(currentKey);
  }, [location.pathname]);
  const [messageApi, contextHolder] = message.useMessage();
  const [modal, contextHolderModal] = Modal.useModal();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const logout = () => {
    modal.confirm({
      centered: true,
      title: <span style={{ color: "#fff" }}>Confirm Logout</span>,
      content: (
        <span style={{ color: "rgba(255, 255, 255, 0.7)" }}>
          Are you sure you want to logout?
        </span>
      ),
      okText: "Logout",
      cancelText: "Cancel",

      onOk: () => {
        localStorage.clear();
        navigate(`/${consts.route}/`);
      },
      okButtonProps: {
        className: "logout-red-btn",
      },
      maskStyle: {
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
      },
      styles: {
        content: {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          color: "white",
          // transform: "translate(50px, 50px)",
        },
      },
    });
  };

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getNotifications();
  }, [role, visibleCount]);
  // }, [dropdownVisible, role, visibleCount]);

  // Real-time notifications via socket — push directly into state (no API re-fetch)
  useEffect(() => {
    const token = localStorage.getItem("Jetix");
    if (!token) return;

    console.log("Admin notification socket connected");
    socket.emit("register_user", { token });

    if (role === "admin" || role === "superadmin" || role === "subadmin") {
      socket.emit("join_admin_notifications", token);
    }

    socket.on("new_notification", (notification) => {
      const notifType = (notification.type || "").replace(/\s+/g, '').toLowerCase();
      if (!ADMIN_NOTIFICATION_TYPES.includes(notifType)) return;

      // Check if this notification is targeted to a specific admin using `to` or `adminId`
      // We use currentAdminRef to safely get the current user's ID without stale closures
      const targetId = notification.to || notification.adminId;
      const currentAdminId = currentAdminRef.current || localStorage.getItem("adminId");

      // If it's targeted, EVERYONE (including superadmins) should only process the one meant for them!
      if (targetId && currentAdminId && targetId.toString() !== currentAdminId.toString()) {
        return;
      }

      // Filter by permission for subadmins
      if (role === "subadmin") {
        const userPermissions = (permissions || JSON.parse(localStorage.getItem("permissions") || "[]")).map(p => p.toLowerCase().trim());
        const requiredPermission = NOTIF_PERMISSION_MAP[notifType];
        if (!requiredPermission || !userPermissions.includes(requiredPermission.toLowerCase().trim())) {
          return;
        }
      }

      // Merge the new notification into existing grouped state if it's not a duplicate
      setNotifications(prev => {
        const isDuplicate = prev.some(group =>
          group.messages?.some(m => m._id === notification._id)
        );
        if (isDuplicate) return prev;

        const idx = prev.findIndex(n => (n.type || "").replace(/\s+/g, '').toLowerCase() === notifType);
        const newMsg = {
          _id: notification._id,
          message: notification.message,
          type: notification.type,
          createdAt: notification.createdAt || new Date().toISOString(),
        };

        let nextState;
        if (idx !== -1) {
          const updated = [...prev];
          updated[idx] = {
            ...updated[idx],
            count: (updated[idx].count || 0) + 1,
            messages: [newMsg, ...(updated[idx].messages || [])],
          };
          nextState = updated;
        } else {
          nextState = [...prev, { type: notification.type, count: 1, messages: [newMsg] }];
        }
        return nextState;
      });

      // Show toast if suitable
      // messageApi.info({
      //   content: notification.message,
      //   icon: <BellFilled style={{ color: "#2EFF0C" }} />,
      //   duration: 4,
      // });
    });

    // socket.on("receive_raised_ticket", (data) => {
    //   if (!data) return;

    //   // The backend emits this event with inconsistent structures:
    //   // 1. { support: { _id, ... }, unreadCount } in AddQuesr.js
    //   // 2. { _id, title, ... } in ReplyForQuery.js and server.js
    //   const ticket = data.support || data;
    //   if (!ticket._id) return;

    //   // Transform ticket into notification format
    //   const supportNotification = {
    //     _id: ticket._id,
    //     message: `New support ticket: ${ticket.title || "No Title"}`,
    //     type: "support",
    //     createdAt: ticket.createdAt || new Date().toISOString(),
    //   };

    //   // Permission check for subadmins
    //   if (role === "subadmin") {
    //     const userPermissions = (permissions || JSON.parse(localStorage.getItem("permissions") || "[]")).map(p => p.toLowerCase().trim());
    //     const requiredPermission = NOTIF_PERMISSION_MAP["support"];
    //     if (!requiredPermission || !userPermissions.includes(requiredPermission.toLowerCase().trim())) {
    //       return;
    //     }
    //   }

    //   // Merge the new notification into existing grouped state if it's not a duplicate
    //   setNotifications(prev => {
    //     const isDuplicate = prev.some(group =>
    //       group.messages?.some(m => m._id === supportNotification._id)
    //     );
    //     if (isDuplicate) return prev;

    //     const idx = prev.findIndex(n => (n.type || "").replace(/\s+/g, '').toLowerCase() === "support");
    //     const newMsg = {
    //       _id: supportNotification._id,
    //       message: supportNotification.message,
    //       type: supportNotification.type,
    //       createdAt: supportNotification.createdAt || new Date().toISOString(),
    //     };

    //     let nextState;
    //     if (idx !== -1) {
    //       const updated = [...prev];
    //       updated[idx] = {
    //         ...updated[idx],
    //         count: (updated[idx].count || 0) + 1,
    //         messages: [newMsg, ...(updated[idx].messages || [])],
    //       };
    //       nextState = updated;
    //     } else {
    //       nextState = [...prev, { type: "support", count: 1, messages: [newMsg] }];
    //     }
    //     return nextState;
    //   });
    // });

    socket.on("clear_notification", (payload) => {
      // payload: { id, type, role, adminId }
      const currentAdminId = localStorage.getItem("adminId");

      setNotifications(prev => {
        if (!prev || !Array.isArray(prev)) return [];
        let nextState = [...prev];

        if (payload.id) {
          // Clear a single specific notification across all groups
          nextState = nextState.map(group => {
            const hasMatch = group.messages?.some(m => m._id?.toString() === payload.id?.toString());
            if (!hasMatch) return group;

            const filteredMsgs = group.messages?.filter(m => m._id?.toString() !== payload.id?.toString());
            return {
              ...group,
              messages: filteredMsgs,
              count: Math.max(0, (group.count || 0) - 1)
            };
          }).filter(group => group.messages && group.messages.length > 0);
        } else if (payload.type) {
          // Clear all notifications of a specific type
          const typeLower = payload.type.replace(/\s+/g, '').toLowerCase();
          nextState = nextState.filter(group => {
            const groupType = (group.type || "").replace(/\s+/g, '').toLowerCase();
            return groupType !== typeLower && !(typeLower === "tradesetting" && groupType === "tradesettings");
          });
        } else {
          // Clear ALL notifications
          // 1. If global admin clears, all clear.
          // 2. If it's the current user who cleared, they should clear their own view.
          const isGlobalClear = payload.role === "admin" || payload.role === "superadmin";
          const isOwnClear = currentAdminId && payload.adminId && payload.adminId.toString() === currentAdminId.toString();

          if (isGlobalClear || isOwnClear) {
            nextState = [];
          }
        }
        return nextState;
      });
    });

    socket.on("disconnect", () => {
      console.log("Admin notification socket disconnected");
    });
  }, [role]);

  // useEffect(() => {
  //   // Check if the script is already added
  //   if (document.getElementById("google-translate-script")) return;

  //   window.googleTranslateElementInit = () => {
  //     if (window.google && window.google.translate) {
  //       new window.google.translate.TranslateElement(
  //         {
  //           pageLanguage: 'en',
  //           includedLanguages: 'ta,hi,fr,de,ja,ar,en',
  //           layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
  //         },
  //         'google_translate_element'
  //       );
  //     }
  //   };

  //   const addScript = document.createElement("script");
  //   addScript.id = "google-translate-script";
  //   addScript.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //   addScript.async = true;
  //   document.body.appendChild(addScript);

  //   // Force remove navbar continuously as requested, but keep the menu iframe
  //   const interval = setInterval(() => {
  //     // 1. Target the specific banner frame ID and class
  //     const banner = document.getElementById(':0.container') || document.querySelector('.goog-te-banner-frame');
  //     if (banner) {
  //         banner.style.setProperty('display', 'none', 'important');
  //         banner.style.setProperty('visibility', 'hidden', 'important');
  //     }

  //     // 2. Scan all iframes to hide the bar but SAVE the menu
  //     const iframes = document.getElementsByTagName('iframe');
  //     for (let i = 0; i < iframes.length; i++) {
  //       const iframe = iframes[i];
  //       const isMenu = iframe.classList.contains('goog-te-menu-frame') || 
  //                      iframe.id.includes('menu') || 
  //                      iframe.src.includes('menu');
        
  //       if (!isMenu) {
  //           // Hide everything that isn't a menu (like the banner or placeholders)
  //           iframe.style.setProperty('display', 'none', 'important');
  //       } else {
  //           // Ensure the menu IS visible when Google tries to show it
  //           iframe.style.setProperty('display', 'block', 'important');
  //       }
  //     }

  //     // 3. Reset body offset
  //     if (document.body.style.top !== '0px') {
  //       document.body.style.top = '0px';
  //     }
  //   }, 500);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  // For subadmins: pre-process the crypto parent item's children based on permissions
  const preparedItems = allItems.map(item => {
    if (item.label?.trim() === "Crypto History" && role === "subadmin" && permissions) {
      const permittedFormatted = permissions.map(p => p.toLowerCase().trim());
      return {
        ...item,
        children: item.children?.filter(child => {
          const reqPerm = CRYPTO_CHILD_PERMISSION_MAP[child.key];
          if (!reqPerm) return false;
          return permittedFormatted.includes(reqPerm.toLowerCase()) || permittedFormatted.includes("crypto history");
        }),
      };
    }
    return item;
  });

  const sidebarItems = preparedItems.filter(item => {
    if (role === "admin" || role === "superadmin") return true;
    if (!permissions) return false;

    const permittedFormatted = permissions.map(p => p.toLowerCase().trim());

    if (item.label?.trim() === "Crypto History") {
      const cryptoPerms = ["highlow", "updown", "highlow spread", "taptrade", "spin and win", "crypto history"];
      const hasAnyCrypto = permittedFormatted.some(p => cryptoPerms.includes(p));
      return hasAnyCrypto && (item.children?.length ?? 0) > 0;
    }

    return permittedFormatted.includes(item.label.toLowerCase().trim());
  });

  // Protect the current route
  useEffect(() => {
    if (profileLoaded && sidebarItems.length > 0) {
      let isAllowed = false;
      for (const item of sidebarItems) {
        if (item.key === currentKey) isAllowed = true;
        if (item.children) {
          for (const child of item.children) {
            if (child.key === currentKey || currentKey.startsWith(item.key)) isAllowed = true;
          }
        }
      }

      if (!isAllowed) {
        // Redirect to the first available route
        const firstAllowed = sidebarItems[0].children ? sidebarItems[0].children[0].key : sidebarItems[0].key;
        navigate(`/${consts.route}${firstAllowed}`, { replace: true });
        setSelectedKey(firstAllowed);
      }
    }
  }, [profileLoaded, currentKey, sidebarItems, navigate]);

  const menu = (
    <Menu
      theme="dark"
      selectedKeys={[selectedKey]}
      // defaultOpenKeys={["/crypto"]}
      mode="inline"
      items={sidebarItems}
      className="side-bar-cls"
      onClick={({ key }) => {
        setSelectedKey(key);
        navigate(`/${consts.route + key}`);
        if (isMobile) setDrawerOpen(false);
      }}
    />
  );

  // Re-define handleClose if it was previously defined differently or remove if redundant
  // (already updated above)

  const totalNew = notifications.reduce((acc, curr) => acc + curr.count, 0);

  const dropdownContent = (() => {

    const getFilteredMessages = () => {
      if (!activeNotificationTab || activeNotificationTab === "All") {
        return notifications.flatMap((n) => (n.messages || []).map(m => ({ ...m, type: n.type })))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      }

      const tabType = activeNotificationTab.replace(/\s+/g, "").toLowerCase();
      const msgs = notifications
        .filter((n) => {
          const notifType = n.type?.replace(/\s+/g, "").toLowerCase();
          return (
            notifType === tabType ||
            (tabType === "tradesetting" && notifType === "tradesettings")
          );
        })
        .flatMap((n) => (n.messages || []).map(m => ({ ...m, type: n.type })));

      return msgs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    };

    const filteredMessages = getFilteredMessages();

    const NOTIFICATION_NAVIGATION = {
      support: "/supports",
      settings: "/settings",
      pairs: "/pairs",
      trade: "/crypto/highlow",
      tradesettings: "/tradesetting",
      user: "/usersHistory",
      deposit: "/deposit",
      withdraw: "/withdraw",
      kyc: "/kyc",
      announcements: "/announcements"
    };

    const handleNotificationClick = (type) => {
      console.log("Notification clicked, type:", type);
      if (!type) return;
      const normalizedType = type.replace(/\s+/g, '').toLowerCase();
      const path = NOTIFICATION_NAVIGATION[normalizedType];
      console.log("Resolved path:", path);
      if (path) {
        navigate(`/${consts.route}${path}`);
        setDropdownVisible(false);
      }
    };

    return (
      <div
        style={{
          // background: "rgba(3, 50, 30, 0.85)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: 20,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 0 0 1px rgba(255, 255, 255, 0.05)",
          width: isMobile ? "300px" : "420px",
          padding: "20px 0",
          color: "#fff",
          border: "1px solid rgba(131, 228, 174, 0.1)",
          position: "relative",
          right: isMobile ? "-20px" : "0",
          overflow: "hidden",
        }}
        className="premium-notification-dropdown"
      >
        {/* Animated Background Glow */}
        <div style={{
          position: "absolute",
          top: -100,
          right: -100,
          width: 200,
          height: 200,
          background: "radial-gradient(circle, rgba(46, 255, 12, 0.1) 0%, transparent 70%)",
          zIndex: 0,
          pointerEvents: "none"
        }} />
        <div style={{ padding: "0 20px 20px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", zIndex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <h3 style={{ margin: 0, color: "#fff", fontSize: 22, fontWeight: 700, letterSpacing: -0.5 }}>Notifications</h3>
            <div style={{
              // background: "rgba(46, 255, 12, 0.1)",
              color: "var(--primary-color)",
              background: "linear-gradient(180deg, rgba(252, 68, 32, 0.2) 0 %, rgba(252, 68, 32, 0.04) 100 %)",

              padding: "4px 10px",
              borderRadius: 30,
              fontSize: 12,
              fontWeight: 600,
              border: "1px solid var(--primary-color)"
            }}>
              {totalNew} New
            </div>
          </div>
        </div>

        {/* Categories Tab Bar */}
        <style>
          {`
            .no-scrollbar::-webkit-scrollbar {
              display: none;
            }
            .no-scrollbar {
              -ms-overflow-style: none;
              scrollbar-width: none;
            }
          `}
        </style>
        <div
          style={{
            display: "flex",
            gap: 8,
            overflowX: "auto",
            padding: "0 16px 16px 16px",
          }}
          className="no-scrollbar"
          ref={setScrollRef}
        >
          {/* All tab (Admin/Superadmin only) */}
          <button
            onClick={() => setActiveNotificationTab("All")}
            style={{
              padding: "10px 20px",
              borderRadius: 30,
              border: "none",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              whiteSpace: "nowrap",
              backgroundColor: activeNotificationTab === "All" ? "var(--primary-color)" : "rgba(255, 255, 255, 0.05)",
              color: activeNotificationTab === "All" ? "#fff" : "rgba(255, 255, 255, 0.6)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              display: "flex",
              alignItems: "center",
              gap: 8,
              boxShadow: activeNotificationTab === "All" ? "0 4px 12px rgba(46, 255, 12, 0.3)" : "none",
            }}
          >
            <span>All</span>
            {totalNew > 0 && (
              <span style={{
                backgroundColor: activeNotificationTab === "All" ? "#03321E" : "var(--primary-color)",
                color: activeNotificationTab === "All" ? "var(--primary-color)" : "#fff",
                borderRadius: "50%",
                minWidth: 20,
                height: 20,
                fontSize: 11,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800
              }}>{totalNew}</span>
            )}
          </button>

          {notificationCategories.filter(cat => cat !== "All").map((cat) => {
            const normalizedCat = cat.replace(/\s+/g, '').toLowerCase();
            const count = notifications
              .filter((n) => {
                const notifType = n.type.replace(/\s+/g, '').toLowerCase();
                return notifType === normalizedCat || (normalizedCat === 'tradesetting' && notifType === 'tradesettings');
              })
              .reduce((acc, curr) => acc + curr.count, 0);

            return (
              <button
                key={cat}
                onClick={() => setActiveNotificationTab(cat)}
                style={{
                  padding: "10px 20px",
                  borderRadius: 30,
                  border: "none",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  backgroundColor: activeNotificationTab === cat ? "var(--primary-color)" : "rgba(255, 255, 255, 0.05)",
                  color: activeNotificationTab === cat ? "#fff" : "rgba(255, 255, 255, 0.6)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  boxShadow: activeNotificationTab === cat ? "0 4px 12px rgba(46, 255, 12, 0.3)" : "none",
                }}
              >
                {cat === "Support" && <MessageOutlined style={{ fontSize: 14 }} />}
                {cat === "Trade" && <RiseOutlined style={{ fontSize: 14 }} />}
                {cat === "Trade Setting" && <RiseOutlined style={{ fontSize: 14 }} />}
                {cat === "User" && <Avatar size={14} style={{ border: "none" }} />}
                {cat === "Deposit" && <DollarOutlined style={{ fontSize: 14 }} />}
                {cat === "Withdraw" && <DollarOutlined style={{ fontSize: 14 }} />}
                {cat === "KYC" && <FileDoneOutlined style={{ fontSize: 14 }} />}
                <span>{cat}</span>
                {count > 0 && (
                  <span style={{
                    backgroundColor: activeNotificationTab === cat ? "#03321E" : "var(--primary-color)",
                    color: activeNotificationTab === cat ? "#fff" : "#03321E",
                    borderRadius: "50%",
                    minWidth: 20,
                    height: 20,
                    fontSize: 11,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 800
                  }}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Content */}
        <div
          onScroll={(e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
            if (scrollHeight - scrollTop <= clientHeight + 50 && !isFetching) {
              // Only fetch more if there's actually more to fetch
              let hasMore = false;
              if (activeNotificationTab === "All") {
                const totalCount = notifications.reduce((acc, n) => acc + (n.count || 0), 0);
                const totalVisible = notifications.reduce((acc, n) => acc + (n.messages?.length || 0), 0);
                hasMore = totalVisible < totalCount;
              } else {
                const group = notifications.find(n => {
                  const notifType = n.type.replace(/\s+/g, '').toLowerCase();
                  const tabType = activeNotificationTab.replace(/\s+/g, '').toLowerCase();
                  return notifType === tabType || (tabType === 'tradesetting' && notifType === 'tradesettings');
                });
                hasMore = group && (group.messages?.length < group.count);
              }

              if (hasMore) {
                setVisibleCount((prev) => prev + 10);
              }
            }
          }}
          style={{ maxHeight: 350, overflowY: "auto", padding: "0 16px" }}
        >
          {filteredMessages.length === 0 ? (
            <div style={{ padding: "40px 0", textAlign: "center", opacity: 0.4 }}>
              <BellFilled style={{ fontSize: 48, marginBottom: 16, color: "#FC4420" }} />
              <p style={{ margin: 0, color: "#fff" }}>No notifications found</p>
            </div>
          ) : (
            <>
              {/* Group Clear (Only for specific types) */}
              {/* Group Clear (Only for specific types) */}
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
                <Button
                  type="link"
                  size="small"
                  loading={isClearingAll}
                  disabled={isClearingAll || clearingId !== null}
                  onClick={() =>
                    handleClose(
                      activeNotificationTab === "All"
                        ? {}
                        : {
                          type: activeNotificationTab
                            .replace(/\s+/g, "")
                            .toLowerCase(),
                        }
                    )
                  }
                  style={{
                    color: "#ff4d4f",
                    padding: 0,
                    fontSize: 12,
                    "&:hover": {
                      color: "#4dff5f",
                    },
                  }}
                  className="clear-all-notif"
                >
                  Clear All{" "}
                  {activeNotificationTab === "All"
                    ? "Messages"
                    : activeNotificationTab}
                </Button>
              </div>

              {filteredMessages.length <= 0 ? (
                <div>
                  No Messages
                </div>
              ) : filteredMessages?.slice(0, visibleCount)?.map((msg) => (
                <div
                  key={msg._id}
                  onClick={() => handleNotificationClick(msg.type)}
                  style={{
                    padding: "16px",
                    borderRadius: 16,
                    backgroundColor: "rgba(255, 255, 255, 0.03)",
                    marginBottom: 12,
                    position: "relative",
                    border: "1px solid rgba(255, 255, 255, 0.05)",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  className="notification-item"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#FC442033";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.03)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.05)";
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                    <div style={{ display: "flex", gap: 12 }}>
                      <div style={{
                        width: 40,
                        height: 40,
                        borderRadius: 12,
                        // backgroundColor: "rgba(46, 255, 12, 0.1)",
                        backgroundColor: "var(--secondary-color)",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#FC4420",
                        flexShrink: 0
                      }}>
                        {msg.type?.toLowerCase().includes('trade') ? <RiseOutlined /> :
                          msg.type?.toLowerCase().includes('deposit') || msg.type?.toLowerCase().includes('withdraw') ? <DollarOutlined /> :
                            msg.type?.toLowerCase().includes('kyc') ? <FileDoneOutlined /> :
                              <BellFilled />}
                      </div>
                      <div>
                        <p style={{ margin: "0 0 4px 0", fontSize: 14, color: "#fff", fontWeight: 500, lineHeight: 1.4 }}>{msg.message}</p>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{
                            color: "#FC4420",
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            opacity: 0.8
                          }}>{msg.type}</span>
                          <span style={{ width: 3, height: 3, borderRadius: "50%", backgroundColor: "rgba(255, 255, 255, 0.2)" }} />
                          <small style={{ color: "rgba(255, 255, 255, 0.4)", fontSize: 11 }}>
                            {new Date(msg.createdAt).toLocaleString([], { hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'short' })}
                          </small>
                        </div>
                      </div>
                    </div>
                    <Tooltip title="Dismiss">
                      {clearingId === msg._id ? (
                        <LoadingOutlined
                          style={{
                            color: "#ff4d4f",
                            fontSize: 16,
                            marginTop: 4,
                          }}
                        />
                      ) : (
                        <CloseCircleOutlined
                          onClick={(e) => {
                            if (isClearingAll || clearingId !== null) return;
                            e.stopPropagation();
                            handleClose({ id: msg._id });
                          }}
                          style={{
                            color: (isClearingAll || clearingId !== null) ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.3)",
                            cursor: (isClearingAll || clearingId !== null) ? "not-allowed" : "pointer",
                            fontSize: 16,
                            marginTop: 4,
                            transition: "color 0.2s"
                          }}
                          onMouseEnter={(e) => {
                            if (isClearingAll || clearingId !== null) return;
                            e.currentTarget.style.color = "#ff4d4f";
                          }}
                          onMouseLeave={(e) => {
                            if (isClearingAll || clearingId !== null) return;
                            e.currentTarget.style.color = "rgba(255, 255, 255, 0.3)";
                          }}
                        />
                      )}
                    </Tooltip>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    );
  })();
  return (
    <>
      {contextHolder}
      {contextHolderModal}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes bellShake {
            0% { transform: rotate(0); }
            15% { transform: rotate(10deg); }
            30% { transform: rotate(-10deg); }
            45% { transform: rotate(5deg); }
            60% { transform: rotate(-5deg); }
            75% { transform: rotate(2deg); }
            85% { transform: rotate(-2deg); }
            100% { transform: rotate(0); }
          }
          .shaking-bell {
            animation: bellShake 2s infinite ease-in-out;
            transform-origin: top center;
          }
          .notification-item {
            animation: fadeIn 0.4s ease-out forwards;
          }
          .premium-notification-dropdown {
            animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          }
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .no-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .logout-red-btn {
            background-color: #ff4d4f !important;
            border-color: #ff4d4f !important;
            color: #fff !important;
          }
          .logout-red-btn:hover {
            background-color: #ff7875 !important;
            border-color: #ff7875 !important;
          }
          // #google_translate_element {
          //   margin-right: 15px;
          // }
          // .goog-te-gadget-simple {
          //   background-color: transparent !important;
          //   border: 1px solid var(--primary-color) !important;
          //   padding: 2px 8px !important;
          //   border-radius: 4px !important;
          //   cursor: pointer !important;
          //   display: flex !important;
          //   align-items: center !important;
          // }
          // .goog-te-gadget-simple .goog-te-menu-value {
          //    color: #fff !important;
          //    font-size: 13px !important;
          //    font-family: inherit !important;
          // }
          // .goog-te-gadget-icon {
          //   display: none !important;
          // }
          // /* Hide the top banner iframe specifically */
          // .goog-te-banner-frame,
          // iframe[id*=".container"] {
          //   display: none !important;
          // }
          // /* Ensure the menu iframe is allowed (it will be injected when you click) */
          // iframe.goog-te-menu-frame {
          //   display: block !important;
          // }
          // .goog-logo-link {
          //   display: none !important;
          // }
          // .goog-te-gadget {
          //   font-size: 0px !important;
          // }
          // .goog-te-gadget .goog-te-combo {
          //   font-size: 12px !important;
          // }
          // body {
          //   top: 0px !important;
          //   position: static !important;
          // }
        `}
      </style>
      <Layout style={{ height: "100vh", overflow: "hidden" }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Sider
            width={200}
            collapsedWidth={80}
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            className="side-bar-cls"
            style={{
              height: "100vh",
              overflowY: "auto",
              position: "sticky",
              top: 0,
              left: 0,

            }}
          >
            <div className="display-3 p-10 mt-10 mb-10">
              <img
                src={logo}
                style={{ width: "90%", height: "100%" }}
                alt="logo"
              />
            </div>

            {menu}
          </Sider>
        )}

        {/* Main Layout */}
        <Layout style={{ overflow: "hidden" }}>
          {/* Header */}
          <Header
            className="header"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            {isMobile && (
              <MenuOutlined
                onClick={() => setDrawerOpen(true)}
                style={{ fontSize: 20, color: "var(--primary-color)" }}
              />
            )}

            {/* <div className="display-1">
              <Tooltip title="Notifications" placement="bottomRight">
                <Dropdown
                  dropdownRender={() => dropdownContent}
                  trigger={["click"]}
                  open={dropdownVisible}
                  onOpenChange={(visible) => setDropdownVisible(visible)}
                >
                  <div className="cursor display-1" id="cs">
                    <BellFilled
                      className="shaking-bell"
                      style={{ color: "var(--primary-color)", fontSize: 25 }}
                    />
                  </div>
                </Dropdown>
              </Tooltip>
</div> */}
            <div className="display-1">
              {/* Bell visible only for admin/superadmin/subadmin */}
              {(role === "admin" || role === "superadmin" || role === "subadmin") && (
                <Dropdown
                  popupRender={() => dropdownContent}
                  trigger={["click"]}
                  open={dropdownVisible}
                  onOpenChange={(visible) => {
                    setDropdownVisible(visible);
                    if (visible) getNotifications();
                  }}
                  placement="bottomRight"
                  overlayStyle={{ zIndex: 1050 }}
                >
                  <div className="cursor display-1 bell-logout-box" id="cs">
                    <Badge
                      count={totalNew}
                      style={{
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        boxShadow: "0 0 0 1px #03321E",
                      }}
                    >
                      <BellFilled
                        className="shaking-bell"
                        style={{ color: "var(--primary-color)", fontSize: 28 }}
                      />
                    </Badge>
                  </div>
                </Dropdown>
              )}

              {/* <div id="google_translate_element"></div> */}

              <Tooltip title="Log out" placement="bottomRight">
                <LogoutOutlined
                  style={{ fontSize: 20, color: "#FD0000" }}
                  className="cursor"
                  onClick={logout}
                />
              </Tooltip>
            </div>
          </Header>

          {/* Content + Footer Wrapper */}
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Scrollable Content */}
            <Content
              style={{
                padding: 16,
                backgroundColor: "var(--background-secondary)",
                flex: 1,
                overflowY: "auto",
              }}
              className="content-area"
            >
              <Outlet />
            </Content>

            {/* Footer */}
            <Footer
              style={{
                textAlign: "center",
                background: "var(--background-secondary)",
                color: "#fff",
                boxShadow: "0 -4px 10px rgba(252, 68, 32, 0.3)", // 👈 top shadow

              }}
            >
              EZ5050 ©{new Date().getFullYear()} All Rights Reserved
            </Footer>
          </div>
        </Layout>

        {/* Mobile Drawer Sidebar */}
        <Drawer
          title={<img src={logo} alt="logo" style={{ width: 120 }} />}
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={240}
          bodyStyle={{ padding: 0 }}
          style={{ backgroundColor: "var( --background-primary)" }}

        >
          <div style={{ height: "100%", overflowY: "auto" }}>{menu}</div>
        </Drawer>
      </Layout>
    </>
  );
};

export default Dashboard;
